import { render } from "./UserBio.vue?vue&type=template&id=4684d328"
import script from "./UserBio.vue?vue&type=script&lang=js"
export * from "./UserBio.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__